import { loadStripe, Stripe } from "@stripe/stripe-js";

let _stripePromise: Promise<Stripe | null> | null = null;

const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

const loadStripeWithRetry = async (maxRetries = 3): Promise<Stripe | null> => {
  for (let attempt = 0; attempt <= maxRetries; attempt++) {
    try {
      const stripe = await loadStripe(import.meta.env.VITE_STRIPE_KEY);
      if (stripe) {
        console.log('Stripe.js loaded successfully');
        return stripe;
      }
      throw new Error('Stripe returned null');
    } catch (error) {
      const isLastAttempt = attempt === maxRetries;
      
      if (isLastAttempt) {
        console.error('Stripe.js failed to load after all retries:', error);
        throw error;
      }
      
      // Exponential backoff: 500ms, 1s, 2s
      const delay = 500 * Math.pow(2, attempt);
      console.warn(`Stripe.js loading failed (attempt ${attempt + 1}/${maxRetries + 1}), retrying in ${delay}ms:`, error);
      await sleep(delay);
    }
  }
  
  throw new Error('Stripe.js loading failed after all retries');
};

export const getStripePromise = () => {
  if (!_stripePromise) {
    _stripePromise = loadStripeWithRetry();
    
    // Reset promise on failure to allow fresh attempts
    _stripePromise.catch(() => {
      _stripePromise = null;
    });
  }

  return _stripePromise;
};

// Keep backward compatibility
export const stripePromise =
  import.meta.env.VITE_E2E_PAYMENT_ENDPOINT_URL
    ? Promise.resolve(null)
    : getStripePromise();
